export default __webpack_public_path__ + "static/media/zine-artwork2.77ceef4f.jpg";